var render = function render(){var _vm=this,_c=_vm._self._c;return _c('validation-provider',{attrs:{"name":_vm.name,"rules":_vm.rules},scopedSlots:_vm._u([{key:"default",fn:function({ errors }){return [_c('div',{staticClass:"row"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.dummy_text),expression:"dummy_text"}],staticClass:"d-none",attrs:{"type":"text"},domProps:{"value":(_vm.dummy_text)},on:{"input":function($event){if($event.target.composing)return;_vm.dummy_text=$event.target.value}}}),_c('div',{class:[
        {
          'col-lg-6': !_vm.small,
        },
        {
          'col-lg-12': _vm.small,
        },
        {
          'col-md-6': !_vm.small,
        },
        {
          'col-md-12': _vm.small,
        },
        'col-sm-12',
      ]},[_c('base-select',{ref:"baseSelect",attrs:{"label":_vm.label,"is_required":_vm.is_required,"options":_vm.dropdownOptions,"field":"selected","value":_vm.selected,"disabled":_vm.disabled ? true : false,"is_invalid":errors && errors?.length ? true : false,"helper_text":_vm.helper_text ? _vm.helper_text : errors && errors?.length ? errors[0] : null,"id":_vm.id,"helper_text_style":_vm.helper_text ? '' : 'color:var(--color-47);',"small":_vm.small,"useI18n":_vm.useI18n,"placeholder":_vm.placeholder,"remoteSearch":_vm.remoteSearch},on:{"change-value":_vm.setValue,"search":function($event){return _vm.$emit('search', $event)}}})],1),(_vm.selectedItem)?_c('div',{class:[
        {
          'col-lg-6': !_vm.small,
        },
        {
          'col-lg-12': _vm.small,
        },
        {
          'col-md-6': !_vm.small,
        },
        {
          'col-md-12': _vm.small,
        },
        'col-sm-12',
        'multiselect-options-list',
      ],style:(_vm.small ? 'margin-bottom:20px' : '')},[_c('div',{staticClass:"multiselect-option"},[_c('div',{staticClass:"cross-icon"},[_c('img',{class:{ 'pointer-events-none': _vm.disabled },attrs:{"src":require("@/assets/images/icons/cross-icon-light.svg"),"alt":"cross-icon"},on:{"click":function($event){$event.stopPropagation();return _vm.removeItem.apply(null, arguments)}}})]),_c('div',{staticClass:"text"},[_vm._v(" "+_vm._s(_vm.getBoxDisplayText(_vm.selectedItem))+" ")])])]):_vm._e()])]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }